import { Package } from 'lucide-react';

import { Card, CardContent, CardHeader, CardTitle } from '../../../components/ui/Card';
import type { RevenuePerProduct } from '../../../hooks/inventory/useInventoryDashboard';

interface RevenuePerProductTableProps {
  data: RevenuePerProduct[];
  className?: string;
}

function formatCents(cents: number): string {
  return `$${(cents / 100).toLocaleString(undefined, { minimumFractionDigits: 0, maximumFractionDigits: 0 })}`;
}

export function RevenuePerProductTable({ data, className = '' }: RevenuePerProductTableProps) {
  return (
    <Card className={`bg-[#221F1F] border-[#504A4A] ${className}`}>
      <CardHeader>
        <CardTitle className="text-text-primary flex items-center gap-2">
          <Package className="w-4 h-4 text-text-secondary" />
          Revenue by product (30d)
        </CardTitle>
      </CardHeader>
      <CardContent>
        {data.length === 0 ? (
          <p className="text-text-secondary text-sm py-6 text-center">
            No POS sales in the last 30 days yet.
          </p>
        ) : (
          <div className="divide-y divide-[#363232]">
            <div className="grid grid-cols-[1fr_80px_80px_120px] gap-3 pb-2 text-xs font-semibold text-white/60 uppercase">
              <div>Product</div>
              <div className="text-right">Variants</div>
              <div className="text-right">Units</div>
              <div className="text-right">Revenue</div>
            </div>
            {data.map((p) => (
              <div
                key={p.product_id}
                className="grid grid-cols-[1fr_80px_80px_120px] gap-3 py-3 text-sm"
              >
                <div className="min-w-0">
                  <div className="text-text-primary truncate">{p.product_name}</div>
                </div>
                <div className="text-right font-mono text-text-primary">{p.variant_count}</div>
                <div className="text-right font-mono text-text-primary">{p.units_sold}</div>
                <div className="text-right font-mono text-text-primary">{formatCents(p.revenue_cents)}</div>
              </div>
            ))}
          </div>
        )}
      </CardContent>
    </Card>
  );
}
